import PropTypes from "prop-types";
import React from "react";
import { Route, Routes } from "react-router-dom";

import { StateContext } from "../../StateContext";
import Bexley from "../Bexley";
import Eltham from "../Eltham";
import FooterHome from "../FooterHome";
import FooterVenue from "../FooterVenue";
import Home from "../Home";
import ScrollToTop from "../ScrollToTop";

import * as styles from "./styles.module.scss";

const App = ({ Router, location, state }) => {
  return (
    <>
      {/* Honeybadger to go here */}
      <StateContext.Provider value={state}>
        <div className={styles.container}>
          <Router location={location}>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/bexley/*" element={<Bexley />} />
              <Route path="/eltham/*" element={<Eltham />} />
            </Routes>
            <Routes>
              <Route path="/" element={<FooterHome />} />
              <Route
                path="/bexley/*"
                element={<FooterVenue location="bexley" />}
              />
              <Route
                path="/eltham/*"
                element={<FooterVenue location="eltham" />}
              />
            </Routes>
          </Router>
        </div>
      </StateContext.Provider>
    </>
  );
};

App.propTypes = {
  location: PropTypes.string,
  Router: PropTypes.element,
  state: PropTypes.object,
};

export default App;
